import { useState } from "react";
import { BG, CARD, CARD2, CARD3, BD, TX, TX2, BL, GR, YL, RD } from "../../utils/constants";
import axios from "../../utils/api";

export default function VerifyEmailGate({ user, onVerified, onLogout }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [resent, setResent] = useState(false);
  const [resending, setResending] = useState(false);

  const submit = async () => {
    if (!/^\d{6}$/.test(code.trim())) { setError("Enter the 6-digit code from your email."); return; }
    setLoading(true); setError("");
    try {
      const res = await axios.post("/api/auth/verify-email", { email: user.email, code: code.trim() });
      onVerified(res.data.user);
    } catch (e) {
      setError(e?.response?.data?.error || "Could not verify code.");
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setResending(true); setError(""); setResent(false);
    try {
      await axios.post("/api/auth/resend-verification", { email: user.email });
      setResent(true);
    } catch (e) {
      setError(e?.response?.data?.error || "Could not resend code.");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="ts-scan-shell" style={{ minHeight: "100vh", background: BG, color: TX, fontFamily: "'IBM Plex Mono',monospace", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=Space+Grotesk:wght@800&display=swap');`}</style>
      <div className="ts-panel" style={{ background: CARD, border: `1px solid ${BD}`, borderRadius: 14, padding: 28, maxWidth: 420, width: "100%", boxShadow: "0 28px 80px rgba(0,0,0,0.45)" }}>
        <div className="ts-gradient-text" style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 900, fontSize: 22, marginBottom: 8 }}>
          Verify your email
        </div>
        <div style={{ color: TX2, fontSize: 11, lineHeight: 1.8, marginBottom: 20 }}>
          We sent a 6-digit code to <span style={{ color: BL }}>{user?.email}</span>. Enter it below to continue.
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: "block", fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 5 }}>VERIFICATION CODE</label>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
            placeholder="123456"
            onKeyDown={(e) => e.key === "Enter" && submit()}
            style={{ width: "100%", background: CARD3, border: `1px solid ${BD}`, borderRadius: 8, padding: "12px 14px", color: TX, fontSize: 20, letterSpacing: 8, textAlign: "center", boxSizing: "border-box", fontFamily: "'IBM Plex Mono', monospace", outline: "none" }}
          />
        </div>

        {resent && (
          <div style={{ background: `${GR}12`, border: `1px solid ${GR}40`, borderRadius: 8, padding: "9px 13px", fontSize: 10, color: GR, marginBottom: 16, lineHeight: 1.5 }}>
            A new code is on its way. Check your inbox (and spam folder).
          </div>
        )}
        {error && (
          <div style={{ background: `${RD}12`, border: `1px solid ${RD}40`, borderRadius: 8, padding: "9px 13px", fontSize: 10, color: RD, marginBottom: 16, lineHeight: 1.5 }}>
            {error}
          </div>
        )}

        <button
          onClick={submit}
          disabled={loading}
          style={{ width: "100%", background: loading ? CARD2 : `linear-gradient(135deg,${GR},${BL})`, border: "none", borderRadius: 10, padding: "13px 0", color: loading ? TX2 : "#000", fontSize: 11, fontWeight: 800, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 2, marginBottom: 10 }}
        >
          {loading ? "VERIFYING..." : "VERIFY →"}
        </button>
        <button
          className="btn"
          onClick={resend}
          disabled={resending}
          style={{ width: "100%", background: CARD2, border: `1px solid ${BD}`, borderRadius: 9, padding: 10, color: resending ? TX2 : YL, fontSize: 9, marginBottom: 10 }}
        >
          {resending ? "SENDING..." : "Resend code"}
        </button>
        <button className="btn" onClick={onLogout} style={{ width: "100%", background: "transparent", border: `1px solid ${BD}`, borderRadius: 9, padding: 10, color: TX2, fontSize: 9 }}>Sign out</button>
      </div>
    </div>
  );
}
